enum CardRequestStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  PENDING_TERMS = "PENDING_TERMS",
  REJECTED = "REJECTED",
  CANCELED = "CANCELED",
}

export default CardRequestStatus;
